/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from './API';
import { ChatInput } from '@/graphql/types/chatInput';
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const generateAccessTokens =
  /* GraphQL */ `mutation GenerateAccessTokens($input: GenerateAccessTokensInput!) {
  generateAccessTokens(input: $input) {
    accessToken
    refreshToken
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GenerateAccessTokensMutationVariables,
    APITypes.GenerateAccessTokensMutation
  >;
export const refreshAccessTokens =
  /* GraphQL */ `mutation RefreshAccessTokens($input: RefreshAccessTokensInput!) {
  refreshAccessTokens(input: $input) {
    accessToken
    refreshToken
    __typename
  }
}
` as GeneratedMutation<
    APITypes.RefreshAccessTokensMutationVariables,
    APITypes.RefreshAccessTokensMutation
  >;
export const signPayload =
  /* GraphQL */ `mutation SignPayload($input: GenerateSignaturePayload!) {
  signPayload(input: $input) {
    timestamp
    signature
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SignPayloadMutationVariables,
    APITypes.SignPayloadMutation
  >;
